import { ReactNode } from 'react'

// Consistent, lightweight header for a job tab's content. The rail already
// tells the user where they are, so this stays quiet: an accent icon chip, a
// title, an optional one-line description, and an optional right-aligned
// actions slot for that section's primary action(s).
interface TabSectionHeaderProps {
  icon: ReactNode
  title: string
  description?: string
  actions?: ReactNode
}

const TabSectionHeader = ({ icon, title, description, actions }: TabSectionHeaderProps) => (
  <div className='jobsection__header'>
    <span className='jobsection__icon'>{icon}</span>
    <div className='jobsection__heading'>
      <h3 className='jobsection__title'>{title}</h3>
      {description && <p className='jobsection__desc'>{description}</p>}
    </div>
    {actions && <div className='jobsection__actions'>{actions}</div>}
  </div>
)

export default TabSectionHeader
